import { NavLink } from "react-router-dom";
import { House, Users, ChartLine, CalendarCheck } from "@phosphor-icons/react";

export const BottomNav = () => {
  const navItems = [
    { to: "/", icon: House, label: "Home" },
    { to: "/customers", icon: Users, label: "Customers" },
    { to: "/sales", icon: ChartLine, label: "Sales" },
    { to: "/schedule", icon: CalendarCheck, label: "Schedule" },
  ];

  return (
    <nav className="bottom-nav" data-testid="bottom-navigation">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          data-testid={`nav-${item.label.toLowerCase()}`}
          end={item.to === "/"}
        >
          <item.icon className="nav-icon" weight="fill" />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
